module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Prologue exclude-auto page-open-auto",
    attrs: {
      "id": "Prologue1"
    }
  }, [_c('div', {
    staticClass: "title-block exclude-auto",
    attrs: {
      "id": "title-block6"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_3"
    }
  }), _c('h1', {
    attrs: {
      "id": "h17"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781783784370_tableofcontents"
    }
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('div', {
    staticClass: "block epigraph exclude-auto",
    attrs: {
      "id": "epigraph1"
    }
  }, [_c('p', {
    attrs: {
      "id": "p86"
    }
  }, [_c('i', [_vm._v("‘Biographies of things can make salient what might otherwise remain obscure.’")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution",
    attrs: {
      "id": "attribution1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGOR KOPYTOFF")]), _vm._v(", "), _c('i', [_vm._v("The Cultural Biography of Things")]), _c('span', {
    staticClass: "ref-note",
    attrs: {
      "id": "rw-ref-note-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#rw-num-note-1"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara",
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("It was December, the dog-end of the year. Across the country, offices hit their annual administrative climax. Work piled up: reports to finish, invoices to issue, Christmas cards to send. I scribbled my signature on letters to people I had never met, compiled spreadsheets, printed out an acreage of labels. I hated not only the grind of endless meetings and stuffing envelopes, but also the secondary nature of this job, centred on assisting someone else’s working life. At home in the evening, I sat and stewed as I knitted a soft blue scarf, a Christmas present for my mother-in-law. Knitting normally soothes me, but the repetitive knit, purl, knit of the scarf did not occupy enough of my mind to wrest away my frustration with work. My mind turned to January, with its promise of newness. I did not want to spend another year in that office. I wanted out."), _c('a', {
    attrs: {
      "id": "pagebreak-rw_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_4"
    }
  }, [_c('p', {
    attrs: {
      "id": "p88"
    }
  }, [_vm._v("Christmas arrived, and I headed south to pay my respects to parents, siblings, friends. After a week squashed into a small house whilst rain thrummed on the windows, I travelled with my husband to visit his family in Grasmere, Cumbria. New Year’s Day dawned clear and cold, and we strode out to shake off the old year’s languor. The frost-nipped air blew in chilly celebration as we got out of the car at Rusland Cross and took our first steps of the year towards High Ickenthwaite.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("Bundled into coats, with scarves wrapping us like untidy parcels, we were pushed along by brisk winter winds. After an hour, we reached the wood at Heald Brow, which was ringed with a fence topped with rusting wire. Caught in the fence’s barbs were tufts of wool, silver in winter’s weak sun. Sheep, at the bounds of their territory, scratched their itches here, leaving traces of themselves on the wire. I pulled away some fibres and rolled them on my palm. Grey, black and white, the strands curled in my hand. They felt waxy against my fingers, soft and greasy with lanolin. I balled the fibres in my pocket, carrying them with me like a charm.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p90"
    }
  }, [_vm._v("Cumbria is a landscape shaped by sheep. The county’s hilly slopes require a particular type of farming: upland shepherding, quite different from its lowland cousin. Old Westmorland and Cumberland’s drystone walls enclose the more fertile land around farms, keeping sheep away from the valleys’ cultivated fields to graze on the fells. This higher pasture is common land: sheep are free to graze as far as their feet can take them. Native Herdwick sheep need no fences: they are ‘heafed’ or ‘hefted’, equipped with internal compasses calibrated to their own acreage.")])]), _c('p', {
    attrs: {
      "id": "p91"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_4"
    }
  }, [_vm._v("By half-past three, the gloaming began to gather in, driving us indoors. Warm and weary, I let the weather pin me to the sofa, where I looked again through my Christmas presents. Inside a paper bag with the tag ‘love from Mum’ were four balls of wool – peaty black, charcoal, dove grey, white. Banded with paper round ")]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_5"
    }
  }, [_vm._v("the middle, this was Shetland Heritage yarn from Jamieson & Smith. Printed on the band was a line of tiny symbols: a shepherd’s crook, a hand dipped in water, an iron crossed through, and – my favourite – three tiny Shetland sheep with horns and curling fleeces, staring down the crook. Three renegades from Britain’s north-east edge, their horns a proud trumpet and a warning.")])]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_5"
    }
  }, [_c('p', {
    attrs: {
      "id": "p92"
    }
  }, [_vm._v("I took a sniff. A strong outdoor smell, rich and greasy, caught my nostrils. It was an unmistakably sheepy funk, the same scent from Heald Brow wood. Woolly fibres waved and snaked away from the yarn’s central strand, black flecked with white, cream specks on brown. This was soft and sturdy Shetland "), _c('i', [_vm._v("oo")]), _vm._v(", the "), _c('i', [_vm._v("w")]), _vm._v(" and "), _c('i', [_vm._v("l")]), _vm._v(" clipped off the English word. Familiar yet strange; the wool had come from among some seven hundred crofts and farms in Shetland’s scattered archipelago, caught between the Atlantic Ocean and the North Sea. My four balls of yarn, fading dark to light, yielded to the pressure in my palm then bounced back, comfortable in their shape. My fingers prickled with the urge to knit them up. What would I make from this hardy wool?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p93"
    }
  }, [_vm._v("I am not new to knitting. Gloves, hats, jumpers, cardigans and bootees: for more than twenty years I’ve made clothes for everyone from baby cousins to grandparents. Like many knitters, I began with a simple scarf. Herald of a lifelong love affair or a short, frustrated passion, making a scarf is a new knitter’s rite of passage. Cast on by Mum, Grandma, friend or neighbour, we are handed down crafty DNA in DK yarn. ‘DK’ is our first shibboleth, an abbreviation for ‘double knitting’, the weight of yarn light enough for inexpert fingers to handle easily but sufficiently thick to soon show progress. Needles looped with a row of simple stitches are placed in eager hands like magic wands. Hands whose muscles must learn new lessons.")])]), _c('p', {
    attrs: {
      "id": "p94"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_5"
    }
  }, [_vm._v("At first we hold too firmly, stabbing and pulling stitches in excitement. Faced with knitting now bunched tight as tweed, ")]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_6"
    }
  }, [_vm._v("we loosen our stitches, which swell, drop and increase in number outside of our control. With its row upon row of knit stitches, the scarf is a teacher in tension. When presented with a hole, a bulge, an unexpected widening, the other knitter is momentarily dismayed. ‘How did you do that?’ comes the question; ‘I don’t know,’ wailed in answer.")])]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_6"
    }
  }, [_c('p', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("Quotidian yet extraordinary, wool has been worn for millennia on every part of the human body. Coated with lanolin, its fibres are waterproof and absorb odour. Wool draws moisture away from the skin, keeping us warmer and dryer than most synthetic fabrics. For several thousand years humans have spun the hair from sheep, goats and llamas using spindles or a spinning wheel, or matted it to form felt. Once twisted into thread, wool fibres can be knitted, or woven into cloth then draped across the floors, walls and windows of our homes, blocking drafts and damp. Wool cocoons our families in its warmth.")]), _vm._v(" "), _c('div', {
    staticClass: "paras blank-line exclude-auto",
    attrs: {
      "id": "blank-line2"
    }
  }, [_c('p', {
    attrs: {
      "id": "p96"
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p97"
    }
  }, [_vm._v("I love the magic of turning yarn into a garment, but I felt stumped by the sheepiness of these small, strongly scented cobs. Would anyone I know want something made with this rich-smelling wool in its proud natural shades? The symbols on the yarn band told me it could not be machine-washed, or ironed, and that its fibres needed hand-washing. It was too full of personality to be subdued into an ordinary knit. This Shetland wool demanded more of its knitter, issuing a challenge and an invitation: that I find a pattern that allowed it to be itself. To do this, I needed to understand its genesis, and its story.")])]), _c('p', {
    attrs: {
      "id": "p98"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_6"
    }
  }, [_vm._v("A woollen thread runs back several thousand years through British history. Long before the Romans, Stone Age Britons used the fleece and hide of sheep for clothes and bedding; spindle whorls found from Shetland to Jersey show that these islands’ people have spun yarn from wool for millennia. Yorkshire’s mill towns swelled on the wealth of wool; the stone churches of the ")]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_7"
    }
  }, [_vm._v("Cotswolds raised spires to their skies in thanks for its abundance. Without wool, Britain would not be itself, and yet it is a history that I barely knew.")])]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_7"
    }
  }, [_c('p', {
    attrs: {
      "id": "p99"
    }
  }, [_vm._v("I decide to unpick Britain’s woolly story. This will be my new year’s quest, starting with 440 metres of fine Shetland wool. I will leave my office job to knit my way across the British Isles. Wool will be my compass and my guidebook – to Fair Isle, Yorkshire, the Cotswolds, and beyond – as I work my way from north to south and east to west. I will write about the wool I find and what I knit with it: why we do it, how we do it, who has done it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("Knitting will shape my journey through the coming year.")])]), _c('div', {
    staticClass: "list-named list-notes exclude-auto",
    attrs: {
      "id": "list-notes1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_7"
    }
  }), _c('h4', {
    attrs: {
      "id": "h43"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_7"
    }
  }), _c('a', {
    attrs: {
      "id": "pagebreak-rw_293"
    }
  }, [_vm._v("Notes")])]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_293"
    }
  }), _c('p', {
    attrs: {
      "id": "p854"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_293"
    }
  }, [_c('span', {
    staticClass: "num-note",
    attrs: {
      "id": "rw-num-note-1"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/#rw-ref-note-1"
    }
  }, [_vm._v("1")]), _vm._v(" Igor Kopytoff, ‘The Cultural Biography of Things: Commoditization as Process’, in "), _c('i', [_vm._v("The Social Life of Things")]), _vm._v(", ed. Arjun Appadurai (Cambridge University Press, 1986), p. 67")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdbe6d38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781783784370_prologue.vue
// module id = 81
// module chunks = 0